// shared/data/searchAttachments.js
import axios from '../config/axios';

export async function searchAttachments({
  token,
  searchTerm,
  searchPayload,
  viewerTypeIds,
  viewerSubtypeIds,
  onlyMine = false,
  pageNumber = 0,
  itemsPerPage = 30,
}) {
  const offset = pageNumber * itemsPerPage;
  console.log('DATA searchTerm', searchTerm);
  console.log('CALL /attachment-search');
  const { data } = await axios.get('/attachment-search', {
    params: {
      searchTerm,
      searchPayload,
      viewerTypeIds,
      viewerSubtypeIds,
      onlyMine,
      limit: itemsPerPage,
      offset,
    },
    headers: { Authorization: `Bearer ${token}` },
  });
  console.log('DATA', data);

  return data;
}
